//#region src/lib/dateTime.ts
var e = new Intl.DateTimeFormat("en-GB", {
	dateStyle: "medium",
	timeStyle: "short",
	timeZone: "UTC"
});
function t(t) {
	return t ? e.format(new Date(t)) : "—";
}
//#endregion
//#region src/lib/person.ts
function n(e) {
	return e.displayName || (e.username ? `@${e.username}` : e.externalId);
}
function r(e, t) {
	let n = t ? `${t} ${e.externalId}` : e.externalId;
	return e.username ? `@${e.username} · ${n}` : n;
}
//#endregion
export { t as formatDateTime, r as personDetail, n as personName };
